/**
 * Presets d'indicateurs pré-configurés + presets personnalisés localStorage.
 */
export const SYSTEM_PRESETS = [
  { id: "clean",       name: "Chart nu",           icon: "◇", desc: "Aucun indicateur (par défaut)",         indicators: [] },
  { id: "beginner",    name: "Débutant",           icon: "🌱", desc: "Volume + MA20 uniquement",              indicators: ["VOL", "MA"] },
  { id: "smc",         name: "Trader Institutionnel", icon: "🏛", desc: "OB + BB + CISD + Volume",             indicators: ["OB", "BB", "CISD", "VOL"] },
  { id: "technical",   name: "Analyse Technique",  icon: "📊", desc: "BOLL + RSI + MACD + Volume",            indicators: ["BOLL", "RSI", "MACD", "VOL"] },
  { id: "momentum",    name: "Momentum Pro",       icon: "⚡", desc: "MACD + RSI + Stochastique + ADX",      indicators: ["MACD", "RSI", "KDJ", "DMI"] },
  { id: "swing",       name: "Swing Trader",       icon: "🌊", desc: "MA + BOLL + RSI + ATR",                 indicators: ["MA", "BOLL", "RSI"] },
  { id: "scalp",       name: "Scalping",           icon: "🎯", desc: "EMA + Volume + Awesome Oscillator",     indicators: ["EMA", "VOL", "AO"] },
];

const CUSTOM_LS_KEY = "qtr-custom-presets";

export function loadCustomPresets() {
  try {
    const raw = localStorage.getItem(CUSTOM_LS_KEY);
    if (raw) {
      const p = JSON.parse(raw);
      if (Array.isArray(p)) return p;
    }
  } catch { /* noop */ }
  return [];
}

export function saveCustomPresets(list) {
  try { localStorage.setItem(CUSTOM_LS_KEY, JSON.stringify(list)); } catch { /* noop */ }
}
